const { BASE_URL } = require("./client");

const GET_CERTIFICATES = BASE_URL + '/get/certificates';
const SAVE_CERTIFICATE = BASE_URL + '/post/certificate';
export {
    GET_CERTIFICATES,
    SAVE_CERTIFICATE
};
